import React from 'react';
import ReactDOM from 'react-dom';

// styles
import 'bootstrap/dist/css/bootstrap.css';
import './styles/globals.css';

// main page
import {IndexPage} from './pages';


ReactDOM.render(<IndexPage/>, document.getElementById('root'));
